import styled from 'styled-components';

const StyledPanelFooter = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
`;

export { StyledPanelFooter };
